'use client';

import React from 'react';

const categories = [
  'Todos', 'Ação', 'Aventura', 'Arcade', 'Puzzle', 'RPG',
  'Estratégia', 'Corridas', 'Terror', 'Plataformas', 'Casual', 'Simulação', 'Outros',
];

interface CategoryChipsProps {
  selected: string;
  onSelect: (cat: string) => void;
}

export default function CategoryChips({ selected, onSelect }: CategoryChipsProps) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-3 mb-4 scrollbar-hide">
      {categories.map((cat) => (
        <button
          key={`chip-${cat}`}
          onClick={() => onSelect(cat)}
          className={`
            flex-shrink-0 px-4 py-2 rounded-xl text-sm font-medium transition-all duration-150
            ${selected === cat
              ? 'gradient-primary text-white shadow-sm'
              : 'bg-card border border-border text-muted-foreground hover:text-foreground hover:border-primary/40'
            }
          `}
        >
          {cat}
        </button>
      ))}
    </div>
  );
}